import SupplementStandardLabel from './SupplementStandardLabel';

export default SupplementStandardLabel;
